import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetAllActiveSubstance() {
  return useQuery(queries.drugCatalog.getAllActiveSubstances())
}
